import React from 'react';
import { Modal } from '../ui/Modal';
import { CTPSummaryTable } from './CTPSummaryTable';
import { CTPAnsweredQuestion } from '../../types/compareThePair';

interface CTPSummaryModalProps {
  isOpen: boolean;
  onClose: () => void;
  answeredQuestions: CTPAnsweredQuestion[];
  nameA: string;
  nameB: string;
  symbolA: string;
  symbolB: string;
  logoUrlA: string | null;
  logoUrlB: string | null;
}

export const CTPSummaryModal: React.FC<CTPSummaryModalProps> = ({
  isOpen,
  onClose,
  answeredQuestions,
  nameA,
  nameB,
  symbolA,
  symbolB,
  logoUrlA,
  logoUrlB,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Summary"
      titleCentered
      headerClassName="p-4 pb-2"
    >
      <CTPSummaryTable
        answeredQuestions={answeredQuestions}
        nameA={nameA}
        nameB={nameB}
        symbolA={symbolA}
        symbolB={symbolB}
        logoUrlA={logoUrlA}
        logoUrlB={logoUrlB}
      />
    </Modal>
  );
};
